<!--
 * @Author: wangwenshuai 644586996@qq.com
 * @Date: 2022-08-12 09:33:10
 * @LastEditors: wangwenshuai 644586996@qq.com
 * @LastEditTime: 2023-11-10 14:19:48
 * @FilePath: \dbarsdgs\src\components\DataDetails\Other\Map.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="leaflat_map">
    <TitleName :TitleName="TitleName"></TitleName>
    <div class="map" id="maps"></div>
  </div>
</template>

<script>
export default {
  props: ["Geojson"],
  data() {
    return {
      // TitleName: "空间位置",
      map: "",
      map_: null,
    };
  },
  computed: {
    TitleName() {
      return this.$t("DataDetails.spaceLocation");
    },
  },
  mounted() {
    this.initDate();
  },
  methods: {
    initDate() {
      this.map = L.map("maps", {
        center: [40.02404009136253, 116.50641060224784], // 地图中心
        zoom: 1, //缩放比列
        zoomControl: false, //禁用 + - 按钮
        doubleClickZoom: false, // 禁用双击放大
        attributionControl: false, // 移除右下角leaflet标识
      });
      // 238fd68ad68ea64586624f950c71a8ad
      L.tileLayer(
        "http://t0.tianditu.gov.cn/DataServer?T=vec_c&x={x}&y={y}&l={z}&tk=238fd68ad68ea64586624f950c71a8ad"
      ).addTo(this.map);
    },
  },
  watch: {
    Geojson(val) {
      //  console.log(JSON.parse(val.geojson).coordinates)
      if(this.map_){
        this.map.removeLayer(this.map_);
      }
      
      this.map_ = L.polygon(JSON.parse(val.geojson).coordinates).addTo(
        this.map
      );
    },
  },
  components: {
    TitleName: () => import("@/components/DataDetails/Other/TitleName.vue"),
  },
};
</script>

<style lang="scss" scoped>
.leaflat_map{
  .map {
  width: 100%;
  height: 180px;
  border-radius: 2px;
  //   background: #ccc;
}
#maps {
  width: 100%;
  height: 180px;
  border-radius: 2px;
  z-index: 1;
}
}


</style>